import React from 'react';
import Lottie from 'react-lottie';
import { Box } from 'theme-ui'
import animationData from '../lotties/team_illustration.json';

export default function App() { 
  const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }
    };
  
  return (
    <Box sx={{ opacity: 'var(--theme-ui-colors-video-dimmable)' }}>
      <Lottie 
	    options={defaultOptions}
      />
    </Box>
  );
}